import Img4 from 'assets/images/margin-onboarding-4.png'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'

import {
  BackButton,
  Button,
  ButtonWrapper,
  ContentWrapper,
  Description,
  Img,
  Title,
  Wrapper
} from './common'

type Props = {
  onNext: () => void
  onPrev: () => void
}

const Positions = ({ onNext, onPrev }: Props) => (
  <Wrapper>
    <Img src={Img4} />
    <ContentWrapper>
      <Title>
        <I18n data={messages.margin_onboarding_positions_title} />
      </Title>
      <Description>
        <I18n data={messages.margin_onboarding_positions_description} />
      </Description>
      <ButtonWrapper>
        <BackButton onClick={onPrev}>
          <I18n data={messages.back} />
        </BackButton>
        <Button onClick={onNext}>
          <I18n data={messages.button_next} />
        </Button>
      </ButtonWrapper>
    </ContentWrapper>
  </Wrapper>
)

export default Positions
